import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Divider, Stack } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import React, { useState } from 'react';
import Colors from '../colors';

const containerStyles = {
    border: 0,
    marginBottom: '6px',
    padding: 0,
    borderRadius: '6px'
}

const msgStyles = {
    color: Colors.darkGray,
    fontSize: '1.2rem',
    fontWeight: '600',
    border: 0,
    marginLeft: '12px'
}

function TailgateFormsAccordion({ date, summaryText, infoContainers, initialExpanded }) {
    const [expanded, setExpanded] = useState(initialExpanded);

    const handleExpansion = (event, isExpanded) => {
        setExpanded(isExpanded);
    };

    return (
        <Accordion
            expanded={expanded}
            onChange={handleExpansion}
            sx={containerStyles} >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ padding: 5, borderRadius: '10px', border: 0 }}>
                <span style={msgStyles}>{`${date} - ${summaryText}`}</span>
            </AccordionSummary >
            <Divider />
            <AccordionDetails style={{ padding: 12, boxShadow: 'none' }}>
                <Stack>
                    {infoContainers?.map((container) => {
                        return (
                            container
                        )
                    })}
                </Stack>

            </AccordionDetails>
        </Accordion>
    )
}

export default TailgateFormsAccordion;